import * as React from 'react'
import type { SVGProps } from 'react'
const SvgNewTab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.096 3.14a35.4 35.4 0 0 1 7.806 0 3.32 3.32 0 0 1 2.93 2.9c.308 2.631.308 5.289 0 7.92a3.32 3.32 0 0 1-2.93 2.9 35.4 35.4 0 0 1-7.806 0 3.32 3.32 0 0 1-2.93-2.9 34 34 0 0 1 0-7.92 3.32 3.32 0 0 1 2.93-2.9m7.667 1.243a34.2 34.2 0 0 0-7.528 0 2.07 2.07 0 0 0-1.827 1.803 32.8 32.8 0 0 0 0 7.628c.11.944.874 1.697 1.827 1.803 2.48.277 5.047.277 7.528 0a2.07 2.07 0 0 0 1.827-1.803 32.8 32.8 0 0 0 0-7.628 2.07 2.07 0 0 0-1.827-1.803"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.717 7.12a.637.637 0 0 1-.625-.626.6.6 0 0 1 .609-.609l4.653.06c.341.005.621.285.626.626l.06 4.654a.6.6 0 0 1-.61.609.637.637 0 0 1-.624-.625l-.041-3.165-5.563 5.563a.617.617 0 0 1-.873-.01.617.617 0 0 1-.011-.873L11.88 7.16z"
    />
  </svg>
)
export default SvgNewTab
